<button
  mat-flat-button
  [class.show-scroll]="showScroll"
  (click)="scrollToTop()"
  class="scroll-to-top only-icon mat-elevation-z2"
  [tabIndex]="0"
  [attr.aria-label]="'general.gototop' | translate">
  <span class="odilo-icon" aria-hidden="true">navigate_upward</span>
</button>
